import { create } from "zustand";

interface CounterState {
  walletAmt: number;
  betAmt: number;

  isGameStart: boolean;
  gameRunning: boolean;

  isWinning: boolean;
  coinFace: string;
  rotationCount: number;
  score: number;
  flipCoinStatus: boolean;
  isSound: boolean;
  isMovieMode: boolean;
  isTurbo: boolean;

  winLoseCount: {
    win: number;
    lose: number;
  };

  liveWageredStatus: {
    profit: number;
    wagered: number;
  };

  totalPlays: {
    isWin: boolean;
    totalPoints: number;
  }[];

  coinFaceSelections: string[];

  isStar: boolean;
  isLiked: boolean;
  isMusic: boolean;

  winningAmt: number;
  setWinningAmt: (value: number) => void;

  soundAction: () => void;
  turboAction: () => void;
  setMovieMode: () => void;
  selectCoinsActions: (value: string) => void;
  gameRunningAction: (value: boolean) => void;
  isWinningAction: (value: boolean) => void;
  rotationAction: (value: number) => void;
  totalScoreAction: (value: number) => void;
  resetGameAction: () => void;
  updateWinLoseCountAction: (type: "win" | "lose") => void;
  liveWageredStatusAction: (type: "profit" | "wagered", value: number) => void;

  resetWinLoseCountAction: () => void;
  totalPlaysAction: (value: { isWin: boolean; totalPoints: number }) => void;
  setIsGameStart: () => void;
  setIsStar: () => void;
  setIsLiked: () => void;
  setIsMusic: () => void;
  flipCoinStatusAction: () => void;

  setWalletAmt: (value: number) => void;
  setBetAmt: (value: number) => void;
}

const useCounterStore = create<CounterState>((set) => ({
  walletAmt: 0,
  betAmt: 0,

  isGameStart: false,
  gameRunning: false,

  isWinning: false,
  coinFace: "",
  rotationCount: 0,
  score: 0,
  flipCoinStatus: false,
  isSound: true,
  isMovieMode: false,
  isTurbo: false,

  winLoseCount: {
    win: 0,
    lose: 0,
  },

  liveWageredStatus: {
    profit: 0,
    wagered: 0,
  },

  totalPlays: [],
  coinFaceSelections: [],

  isStar: false,
  isLiked: false,
  isMusic: false,

  winningAmt: 0,

  setWinningAmt: (value) =>
    set(() => ({ winningAmt: parseFloat(value.toFixed(2)) })),

  setWalletAmt: (value) => set(() => ({ walletAmt: value })),
  setBetAmt: (value) => set(() => ({ betAmt: value })),

  setIsMusic: () => set((state) => ({ isMusic: !state.isMusic })),
  setIsStar: () => set((state) => ({ isStar: !state.isStar })),
  setIsLiked: () => set((state) => ({ isLiked: !state.isLiked })),
  setMovieMode: () => set((state) => ({ isMovieMode: !state.isMovieMode })),

  setIsGameStart: () => set((state) => ({ isGameStart: !state.isGameStart })),
  gameRunningAction: (value) => set(() => ({ gameRunning: value })),
  isWinningAction: (value) => set(() => ({ isWinning: value })),
  rotationAction: (value) => set(() => ({ rotationCount: value })),
  totalScoreAction: (value) => set(() => ({ score: value })),

  flipCoinStatusAction: () =>
    set((state) => ({ flipCoinStatus: !state.flipCoinStatus })),

  selectCoinsActions: (value) =>
    set((state) => ({
      coinFaceSelections: [...state.coinFaceSelections, value],
    })),

  resetGameAction: () =>
    set(() => ({
      coinFace: "",
      coinFaceSelections: [],
      gameRunning: false,
      isWinning: false,
    })),

  soundAction: () => set((state) => ({ isSound: !state.isSound })),
  turboAction: () => set((state) => ({ isTurbo: !state.isTurbo })),

  updateWinLoseCountAction: (type) =>
    set((state) => ({
      winLoseCount: {
        ...state.winLoseCount,
        [type]: state.winLoseCount[type] + 1,
      },
    })),

  liveWageredStatusAction: (type, value) =>
    set((state) => {
      return {
        liveWageredStatus: {
          ...state.liveWageredStatus,
          [type]: type === "wagered" ? +value : value,
        },
      };
    }),

  resetWinLoseCountAction: () =>
    set(() => ({
      winLoseCount: {
        win: 0,
        lose: 0,
      },
      liveWageredStatus: {
        profit: 0,
        wagered: 0,
      },
    })),

  totalPlaysAction: (value) =>
    set((state) => {
      const updatedPlays = [...state.totalPlays, value];
      if (updatedPlays.length > 9) updatedPlays.shift();
      return { totalPlays: updatedPlays };
    }),
}));

export default useCounterStore;
